var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.errors.length
    ? _c(
        "ul",
        { staticClass: "errors-messages" },
        _vm._l(_vm.errors, function(error, index) {
          return _c("li", { key: index }, [
            _vm._v("\n    " + _vm._s(_vm.$t(`errors.${error}`)) + "\n  ")
          ])
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }